"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(_ref) {
  var style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    style: style,
    xmlns: "http://www.w3.org/2000/svg",
    height: "11.33",
    width: "17",
    viewBox: "0 0 17 11.33"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.7,1a.31.31,0,0,1,.3.3V10a.3.3,0,0,1-.3.3H1.3A.3.3,0,0,1,1,10V1.3A.31.31,0,0,1,1.3,1H15.7m0-1H1.3A1.3,1.3,0,0,0,0,1.3V10a1.3,1.3,0,0,0,1.3,1.3H15.7A1.3,1.3,0,0,0,17,10V1.3A1.3,1.3,0,0,0,15.7,0Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.43,4.93a1.44,1.44,0,0,1,.21.83V7.51H4.81V5.87a.73.73,0,0,0-.09-.42.3.3,0,0,0-.26-.11.47.47,0,0,0-.27.07,1.36,1.36,0,0,0-.25.2v1.9H3.11v-4h.83v1L3.9,5a2.07,2.07,0,0,1,.37-.27,1,1,0,0,1,.5-.12A.75.75,0,0,1,5.43,4.93Zm2.26,2-.14,0a.33.33,0,0,1-.26-.11.46.46,0,0,1-.1-.34V5.35h.67V4.7H7.19V4H6.5l-.1.75L6,4.73v.62h.38V6.49a1.51,1.51,0,0,0,.06.44.82.82,0,0,0,.17.35.76.76,0,0,0,.3.22,1.15,1.15,0,0,0,.44.08,1.28,1.28,0,0,0,.36,0L8,7.48l-.13-.61Zm2,0-.14,0a.35.35,0,0,1-.26-.11.46.46,0,0,1-.1-.34V5.35h.68V4.7H9.14V4H8.45l-.1.75-.43,0v.62h.39V6.49a2,2,0,0,0,0,.44,1,1,0,0,0,.17.35.84.84,0,0,0,.3.22,1.21,1.21,0,0,0,.45.08,1.25,1.25,0,0,0,.35,0l.27-.06-.13-.61Zm3.2-1.44a1.83,1.83,0,0,1,.08.59,1.79,1.79,0,0,1-.1.64,1.4,1.4,0,0,1-.27.48,1,1,0,0,1-.81.4.94.94,0,0,1-.36-.08,1,1,0,0,1-.31-.22l0,.45v.82h-.84V4.7h.68L11,5h0a1.85,1.85,0,0,1,.37-.25.94.94,0,0,1,.43-.1,1.15,1.15,0,0,1,.46.1,1.09,1.09,0,0,1,.35.29A1.55,1.55,0,0,1,12.84,5.47Zm-.78.6c0-.51-.16-.76-.48-.76a.67.67,0,0,0-.48.26V6.72a.9.9,0,0,0,.22.14.93.93,0,0,0,.22,0,.45.45,0,0,0,.37-.2A1,1,0,0,0,12.06,6.07Zm1.83-.33a.5.5,0,0,0,.5-.52.51.51,0,0,0-.14-.38.51.51,0,0,0-.72,0,.52.52,0,0,0-.15.38.5.5,0,0,0,.15.37A.49.49,0,0,0,13.89,5.74Zm0,.79a.49.49,0,0,0-.36.15.52.52,0,0,0-.15.38.51.51,0,0,0,.15.37.51.51,0,0,0,.72,0,.5.5,0,0,0,.14-.37.51.51,0,0,0-.14-.38A.49.49,0,0,0,13.89,6.53Z"
  }))));
};

exports["default"] = _default;